import AppFunctions from '../helpers/AppFunctions'

export default {
    data() {
        return {
			categories: '',
            tags: '',
			
			edgeProductsIntroKey:'',
			edgeProductsIntro:[],			
			
			menuList: [
				{
					slug: '1',
					name: '边缘控制器',
					isSubShow: false,
					isSelected:false,
					subItems:[
					{ slug: '1_1', name:'PAG系列', isSelected:false },
					{
						slug: '1_2', name:'MEG系列', isSelected:false, isSubShow:false,
						subItems:[
							{ slug: '1_2_1', name:'主控制器', isSelected:false },
							{ slug: '1_2_2', name:'MEG拓展IO模块', isSelected:false }
						]
					}
				]
				},
				{
					slug: '2',
					name: 'MAC系列控制器',
					isSubShow: false,
					isSelected:false,
					subItems:[
						{ slug: '2_1', name:'MAC中型控制器', isSelected:false },
						{ slug: '2_2', name:'MAC运动控制器', isSelected:false },
						{ slug: '2_3', name:'冗余主控器', isSelected:false }
					]
				},
				{
					slug: '3',
					name: '分布式控制器',
					isSubShow: false,
					isSelected:false,
					subItems:[
						{ slug: '3_1', name:'以太网控制器', isSelected:false },
						{ slug: '3_2', name:'分布式扩展模块', isSelected:false }
					]
				},
				{
					slug: '4',
					name: 'EDC系列可编程嵌入式开发平台',
					isSubShow: false,
					isSelected:false,
					subItems:[]
				},
				{
					slug: '5',
					name: 'CIO系列小型控制器',
					isSubShow: false,
					isSelected:false,
					subItems:[]
				},
				{
					slug: '6',
					name: '扩展IO模块',
					isSubShow: false,
					isSelected:false,
					subItems:[
						{ slug: '6_1', name:'开关量输入模块', isSelected:false },
						{ slug: '6_2', name:'开关量输出模块', isSelected:false },
						{ slug: '6_3', name:'模拟量输入模块', isSelected:false },
						{ slug: '6_4', name:'模拟量输出模块', isSelected:false },
						{ slug: '6_5', name:'模拟量输入输出模块', isSelected:false },
						{ slug: '6_6', name:'电力监控扩展模块', isSelected:false },
						{ slug: '6_7', name:'温控及采集模块', isSelected:false }
					]
				},
				{
					slug: '7',
					name: '电源模块',
					isSubShow: false,
					isSelected:false,
					subItems:[]
				},
				{
					slug: '8',
					name: '专用产品',
					isSubShow: false,
					isSelected:false,
					subItems:[]
				},
				{
					slug: '9',
					name: '环网伺服器与伺服电机',
					isSubShow: false,
					isSelected:false,
					subItems:[
						{ slug: '9_1', name:'环网伺服器', isSelected:false },
						{ slug: '9_2', name:'伺服电机', isSelected:false }
					]
				},
				{
					slug: '10',
					name: '软件产品',
					isSubShow: false,
					isSelected:false,
					subItems:[]
				}
			],
            AppFunctions
        }
    },
    methods: { 
    
		/* 获取产品类型信息 */
		getCategoriesData(SerialID){
			let data = [];
			
			// 主分类ID到子分类ID的映射
			const mainCategoryToChildren = {
				'1': ['1_1', '1_2'],              // 边缘控制器
				'1_2': ['1_2_1', '1_2_2'],        // MEG系列
				'2': ['2_1', '2_2', '2_3'],       // MAC系列控制器
				'3': ['3_1', '3_2'],              // 分布式控制器
				'6': ['6_1', '6_2', '6_3', '6_4', '6_5', '6_6', '6_7'],  // 扩展IO模块
				'9': ['9_1', '9_2'],              // 环网伺服器
			};
			
			// 所有有效的新ID集合（主分类ID + 子分类ID）
			const validNewIds = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10',
				'1_1', '1_2', '1_2_1', '1_2_2',
				'2_1', '2_2', '2_3',
				'3_1', '3_2',
				'6_1', '6_2', '6_3', '6_4', '6_5', '6_6', '6_7',
				'9_1', '9_2'
			];
			
			// 旧ID到新ID的映射（仅旧ID范围：11-22, 13-19等大于10的ID）
			const oldToNewId = {
				'21': '1_1', '22': '1_2',
				'20': '2_3',
			};
			
			// 兼容旧ID：只有不在新ID集合中的才转换
			if (validNewIds.indexOf(SerialID) === -1 && oldToNewId[SerialID]) {
				SerialID = oldToNewId[SerialID];
			}
			
			// 如果是主分类ID，递归获取所有子分类的数据
			const childIds = mainCategoryToChildren[SerialID];
			if (childIds && childIds.length > 0) {
				let allData = [];
				for (let i = 0; i < childIds.length; i++) {
					this.getCategoriesData(childIds[i]);
					allData = allData.concat(this.edgeProductsIntro);
				}
				this.edgeProductsIntroKey = SerialID;
				this.edgeProductsIntro = allData;
				return;
			}
			
			// PAG系列 1_1 (ID: 101-110)
			if(SerialID == '1_1'){
				data=[
					{
						id: '101',
						thumbnail:require('@/assets/images/edge/Active/产品页/01_边缘控制器/PAG系列/产品缩略图/PAG310_1-1.jpg'),
						PTName:'PAG310',
						Resource:'数字量输入：5路，<br/>包含4路20kHz高速</br>数字量输出：2路</br>以太网(100M)：2路</br>RS485：4路',
						Intro:'支持MQTT、EPA、Profinet、EtherCAT、Ethernet/IP多种通信协议互联，支持Modbus TCP/UDP透明传输</br>支持边缘数据管理、设备变量映射管理、多协议功能块执行处理、控制网络互联。'
					},
					{
						id: '102',
						thumbnail:require('@/assets/images/edge/Active/产品页/01_边缘控制器/PAG系列/产品缩略图/PAG313_1-1.jpg'),
						PTName:'PAG313',
						Resource:'数字量输入：5路，<br/>包含4路20kHz高速</br>数字量输出：4路</br>以太网(100M)：2路</br>RS485：3路',
						Intro:'功能上与PAG310完全相同，舍弃一个RS485接口，换取2路数字量输出。'
					}
				]
			}
			// MEG系列-主控制器 1_2_1 (ID: 111)
		else if(SerialID == '1_2_1'){
			data=[
				{
					id: '111',
					thumbnail:require('@/assets/images/edge/Active/产品页/01_边缘控制器/MEG系列/产品缩略图/MEG300_Z.png'),
					PTName:'MEG300',
					Resource:'2路100M以太网，1路RS485</br>支持EPA、Profinet、EtherCAT等协议</br>支持FBD、LAD、ST多种编程语言',
					Intro:'边缘控制器'
				},
			]
		}
		// MEG系列-MEG拓展IO模块 1_2_2 (ID: 112-116)
		else if(SerialID == '1_2_2'){
			data=[
				{
					id: '112',
					thumbnail:require('@/assets/images/edge/Active/产品页/01_边缘控制器/MEG系列/产品缩略图/EDI16_Z.png'),
					PTName:'EDI16',
					Resource:'16路数字量输入DI</br>双向输入，源型/漏型</br>底板总线速度10Mbps',
					Intro:'开关量输入模块'
				},
				{
					id: '113',
					thumbnail:require('@/assets/images/edge/Active/产品页/01_边缘控制器/MEG系列/产品缩略图/EDQ16_Z.png'),
					PTName:'EDQ16',
					Resource:'16路数字量输出DQ</br>NPN/PNP输出型可选</br>输出负载500mA/通道',
					Intro:'开关量输出模块'
				},
				{
					id: '116',
					thumbnail:require('@/assets/images/edge/Active/产品页/01_边缘控制器/MEG系列/产品缩略图/EDQ04_Z.png'),
					PTName:'EDQ04',
					Resource:'4路数字量输出DQ</br>继电器输出，2A/通道</br>DC 30V / AC 250V',
					Intro:'继电器输出模块'
				},
				{
					id: '114',
					thumbnail:require('@/assets/images/edge/Active/产品页/01_边缘控制器/MEG系列/产品缩略图/EAI06_Z.png'),
					PTName:'EAI06',
					Resource:'6路模拟量输入AI</br>电压/电流/热偶/热阻多种类型</br>24位Δ-Σ型ADC',
					Intro:'模拟量输入模块'
				},
				{
					id: '115',
					thumbnail:require('@/assets/images/edge/Active/产品页/01_边缘控制器/MEG系列/产品缩略图/EAQ08_Z.png'),
					PTName:'EAQ08',
					Resource:'8路模拟量输出AQ</br>电压/电流输出型可选</br>16位DAC，输出精度±0.05%',
					Intro:'模拟量输出模块'
				},
			]
		}
			// MAC中型控制器 2_1 (ID: 121-130)
			else if(SerialID == '2_1'){
				data=[
					{
						id: '121',
						thumbnail:require('@/assets/images/edge/Active/产品页/02_MAC系列控制器/MAC中型控制器/产品缩略图/MAC1100_1-1.jpg'),
						PTName:'MAC1100',
						Resource:'数字量输入：23路，<br/>包含4路20kHz高速</br>数字量输出：16路，<br/>包含2路5kHz高速</br>以太网(100M)：1路</br>RS485：2路',
						Intro:'晶体管输出型'
					},
					{
						id: '122',
						thumbnail:require('@/assets/images/edge/Active/产品页/02_MAC系列控制器/MAC中型控制器/产品缩略图/MAC1110_1-1.jpg'),
						PTName:'MAC1110',
						Resource:'数字量输入：16路，<br/>包含4路20kHz高速</br>数字量输出：16路，<br/>包含2路5kHz高速</br>以太网(100M)：1路</br>RS485：2路',
						Intro:'继电器输出型'
					},
					{
						id: '123',
						thumbnail:require('@/assets/images/edge/Active/产品页/02_MAC系列控制器/MAC中型控制器/产品缩略图/MAC1120_1-1.jpg'),
						PTName:'MAC1120',
						Resource:'数字量输入：24路，<br/>包含4路20kHz高速</br>数字量输出：12路，<br/>包含2路5kHz高速</br>以太网(100M)：1路</br>RS485：2路',
						Intro:'继电器输出型</br>串口可与外部共地'
					}
				]
			}
			// MAC运动控制器 2_2 (ID: 131-140)
			else if(SerialID == '2_2'){
				data=[
					{
						id: '131',
						thumbnail:require('@/assets/images/edge/Active/产品页/02_MAC系列控制器/MAC运动控制器/产品缩略图/MAC160_1-1.jpg'),
						PTName:'MAC160',
						Resource:'数字量输入：5路，<br/>包含4路500kHz高速</br>数字量输出：2路500KHz高速</br>以太网(100M)：2路</br>RS485：4路',
						Intro:'支持环网控制、单轴多轴轴组，支持G代码编程</br>支持单轴、多轴和轴组运动控制指令、数控G代码和多种机器人模型'
					},
					{
						id: '132',
						thumbnail:require('@/assets/images/edge/Active/产品页/02_MAC系列控制器/MAC运动控制器/产品缩略图/MAC1132_1-1.jpg'),
						PTName:'MAC1132',
						Resource:'数字量输入：23路，<br/>包含8路500kHz高速</br>数字量输出：16路，<br/>包含8路500kHz高速</br>以太网(100M)：1路</br>RS485：2路',
						Intro:'支持单轴运动控制指令；支持4个实轴、4个虚轴'
					},
					{
						id: '133',
						thumbnail:require('@/assets/images/edge/Active/产品页/02_MAC系列控制器/MAC运动控制器/产品缩略图/MAC1133_1-1.jpg'),
						PTName:'MAC1133',
						Resource:'数字量输入：23路，<br/>包含8路500kHz高速</br>数字量输出：16路，<br/>包含8路500kHz高速</br>以太网(100M)：1路</br>RS485：2路',
						Intro:'支持单轴运动控制指令；支持8个实轴、4个虚轴'
					},
					{
						id: '134',
						thumbnail:require('@/assets/images/edge/Active/产品页/02_MAC系列控制器/MAC运动控制器/产品缩略图/MAC1630_1-1.jpg'),
						PTName:'MAC1630',
						Resource:'数字量输入：23路，<br/>包含8路500kHz高速</br>数字量输出：16路，<br/>包含8路500kHz高速</br>以太网(100M)：1路</br>RS485：2路',
						Intro:'支持8个实轴、4个虚轴和4个轴组</br>支持G代码编程</br>内置数控G代码与多种机器人模型'
					},
					{
						id: '135',
						thumbnail:require('@/assets/images/edge/Active/产品页/02_MAC系列控制器/MAC运动控制器/产品缩略图/MAC1680_1-1.jpg'),
						PTName:'MAC1680',
						Resource:'数字量输入：35路，<br/>包含4路500kHz高速</br>数字量输出：24路500KHz高速</br>以太网(100M)：1路</br>RS485：2路',
						Intro:'支持8个实轴、4个虚轴和4个轴组</br>支持G代码编程</br>内置数控G代码与多种机器人模型'
					}
				]
			}
			// 冗余主控器 2_3 (ID: 141-150)
			else if(SerialID == '2_3'){
				data = [
					{
						id: '141',
						thumbnail:require('@/assets/images/edge/Active/产品页/02_MAC系列控制器/冗余主控器/产品缩略图/MAC320_Z.png'),
						PTName:'MAC320',
						Resource:'数字量输入：5路，<br/>包含4路高速(最大1MHz)</br>数字量输出：2路(晶体管)</br>以太网(100M)：2路</br>RS485：4路',
						Intro:'冗余主控器，</br>具备以太网、串口、设备等多种冗余架构，</br>内部资源丰富，适用于复杂冗余系统的主控'
					},
					{
						id: '142',
						thumbnail:require('@/assets/images/edge/Active/产品页/02_MAC系列控制器/冗余主控器/产品缩略图/MAC323_Z.png'),
						PTName:'MAC323',
						Resource:'数字量输入：5路，<br/>包含4路高速(最大1MHz)</br>数字量输出：4路(晶体管)，<br/>包含2路高速脉冲(最大300KHz)</br>以太网(100M)：2路</br>RS485：3路',
						Intro:'冗余主控器，</br>具备以太网、串口、设备等多种冗余架构，</br>内部资源丰富，适用于复杂冗余系统的主控'
					}
				]
			}
			// 以太网控制器 3_1 (ID: 151-160)
			else if(SerialID == '3_1'){
				data = [
					{
						id: '151',
						thumbnail:require('@/assets/images/edge/Active/产品页/03_分布式控制器/以太网控制器/产品缩略图/PEC3000_1-1.jpg'),
						PTName:'PEC3000',
						Resource:'数字量输入：24路，<br/>包含4路500KHz高速</br>数字量输出：16路，<br/>包含2路30KHz高速</br>以太网(100M)：1路</br>RS485：2路',
						Intro:''
					},
					{
						id: '152',
						thumbnail:require('@/assets/images/edge/Active/产品页/03_分布式控制器/以太网控制器/产品缩略图/PEC5000_aodo_1-1.jpg'),
						PTName:'PEC5000',
						Resource:'数字量输入：1路</br>数字量输出：9路</br>模拟量输入：8路<br/>模拟量输出：无</br>以太网(100M)：1路</br>RS485：2路',
						Intro:'包含模拟量输出款。即端口资源为：</br>数字量输入：1路</br>数字量输出：1路</br>模拟量输入：8路<br/>模拟量输出：8路'
					},					
					{
						id: '153',
						thumbnail:require('@/assets/images/edge/Active/产品页/03_分布式控制器/以太网控制器/产品缩略图/PEC8000_1-1.jpg'),
						PTName:'PEC8000',
						Resource:'数字量输入：8路，<br/>包含4路500KHz高速</br>数字量输出：8路，<br/>包含2路30KHz高速</br>模拟量输入：6路<br/>模拟量输出：2路</br>以太网(100M)：1路</br>RS485：2路',
						Intro:''
					},
					{
						id: '154',
						thumbnail:require('@/assets/images/edge/Active/产品页/03_分布式控制器/以太网控制器/产品缩略图/PEC9000_Z.png'),
						PTName:'PEC9000',
						Resource:'数字量输入：16路</br>数字量输出：16路</br>模拟量输入：8路高速<br/>模拟量输出：8路高速</br>以太网(100M)：1路</br>RS485：2路',
						Intro:'以太网型高速混合控制器，</br>支持IEC61131-3标准的梯形图、功能块编程，</br>支持EPA、Modbus、Profibus-DP、USS等主流控制网络协议'
					}
				]
			}
			// 分布式扩展模块 3_2 (ID: 161-170)
			else if(SerialID == '3_2'){
				data = [
					{
						id: '161',
						thumbnail:require('@/assets/images/edge/Active/产品页/03_分布式控制器/分布式扩展模块/产品缩略图/PMC_2000A_1-1.png'),
						PTName:'PMC2000',
						Resource:'数字量输入：8路，<br/>包含4路20KHz高速</br>数字量输出：8路</br>模拟量输入：6路<br/>模拟量输出：2路</br>以太网(100M)：无</br>RS485：2路',
						Intro:'以太网型混合控制器，</br>支持IEC61131-3标准的梯形图、功能块编程，</br>支持EPA、Modbus、USS等主流控制网络协议'
					},
					{
						id: '162',
						thumbnail:require('@/assets/images/edge/Active/产品页/03_分布式控制器/分布式扩展模块/产品缩略图/AIO5000_aodo_1-1.jpg'),
						PTName:'AIO5000',
						Resource:'数字量输入：1路</br>数字量输出：9路</br>模拟量输入：8路<br/>模拟量输出：无</br>以太网(100M)：无</br>RS485：2路',
						Intro:'从设备扩展模块，无以太网</br>包含模拟量输出款。即端口资源为：<br/>数字量输入：1路</br>数字量输出：1路</br>模拟量输入：8路<br/>模拟量输出：8路'
					},
					{
						id: '163',
						thumbnail:require('@/assets/images/edge/Active/产品页/03_分布式控制器/分布式扩展模块/产品缩略图/DIO2000_1-1.png'),
						PTName:'DIO2000',
						Resource:'数字量输入：23路</br>数字量输出：12路</br>模拟量输入：无<br/>模拟量输出：2路</br>以太网(100M)：无</br>RS485：1路',
						Intro:'不支持编程功能'
					},
					{
						id: '164',
						thumbnail:require('@/assets/images/edge/Active/产品页/03_分布式控制器/分布式扩展模块/产品缩略图/DIO3000_1-1.jpg'),
						PTName:'DIO3000',
						Resource:'数字量输入：24路，<br/>包含4路高速</br>数字量输出：16路，<br/>包含2路高速</br>模拟量输入：无<br/>模拟量输出：2路</br>以太网(100M)：无</br>RS485：2路',				
						Intro:'从设备扩展模块，无以太网'
					}
				]
			}
			// EDC系列 4 (ID: 171-180)
			else if(SerialID == '4'){
				data = [					
					{
						id: '171',
						thumbnail:require('@/assets/images/edge/Active/产品页/04_EDC系列/产品缩略图/EDC3200_1-1.png'),
						PTName:'EDC3200',
						Resource:'数字量输入：24路</br>数字量输出：16路</br>模拟量输入：无<br/>模拟量输出：无</br>以太网(100M)：1路</br>RS485：2路',
						Intro:'继电器输出型'
					},
					{
						id: '172',
						thumbnail:require('@/assets/images/edge/Active/产品页/04_EDC系列/产品缩略图/EDC5000DQ_1-1.png'),
						PTName:'EDC5000DQ',
						Resource:'数字量输入：4路</br>数字量输出：9路</br>模拟量输入：8路<br/>模拟量输出：无</br>以太网(100M)：1路</br>RS485：2路',
						Intro:'数字量输出型嵌入式开发平台'
					},
					{
						id: '173',
						thumbnail:require('@/assets/images/edge/Active/产品页/04_EDC系列/产品缩略图/EDC5000AQ_1-1.png'),
						PTName:'EDC5000AQ',
						Resource:'数字量输入：4路</br>数字量输出：无</br>模拟量输入：8路<br/>模拟量输出：9路</br>以太网(100M)：1路</br>RS485：2路',
						Intro:'模拟量输出型嵌入式开发平台'
					},
					{
						id: '174',
						thumbnail:require('@/assets/images/edge/Active/产品页/04_EDC系列/产品缩略图/EDC8000_1-1.jpg'),
						PTName:'EDC8000',
						Resource:'数字量输入：8路500KHz高速</br>数字量输出：9路，<br/>包含2路30KHz高速</br>模拟量输入：6路<br/>模拟量输出：2路</br>以太网(100M)：1路</br>RS485：2路',
						Intro:'混合型嵌入式开发平台'
					},
					{
						id: '175',
						thumbnail:require('@/assets/images/edge/Active/产品页/04_EDC系列/产品缩略图/EDC8601_1-1.png'),
						PTName:'EDC8601',
						Resource:'数字量输入：8路</br>数字量输出：6路</br>模拟量输入：无<br/>模拟量输出：无</br>以太网(100M)：1路</br>RS485：2路',
						Intro:'继电器输出型嵌入式开发平台'
					},
				]
			}
			// CIO系列 5 (ID: 181-190)
			else if(SerialID == '5'){
				data = [
					{
						id: '181',
						thumbnail:require('@/assets/images/edge/Active/产品页/05_CIO系列小型控制器/产品缩略图/CIO110_1-1.jpg'),
						PTName:'CIO110',
						Resource:'数字量输入：11路，<br/>包含4路20KHz高速</br>数字量输出：8路</br>模拟量输入：无<br/>模拟量输出：无</br>以太网(100M)：无</br>RS485：2路',
						Intro:'晶体管输出</br>单层壳体'
					},
					{
						id: '182',
						thumbnail:require('@/assets/images/edge/Active/产品页/05_CIO系列小型控制器/产品缩略图/CIO200_1-1.png'),
						PTName:'CIO200',
						Resource:'数字量输入：16路</br>数字量输出：12路，<br/>包含2路100KHz高速</br>模拟量输入：无<br/>模拟量输出：无</br>以太网(100M)：无</br>RS485：2路</br>RS232：1路',
						Intro:'卧式壳体</br>端子接线'
					},
					{
						id: '183',
						thumbnail:require('@/assets/images/edge/Active/产品页/05_CIO系列小型控制器/产品缩略图/CIO210_1-1.png'),
						PTName:'CIO210',
						Resource:'数字量输入：16路，<br/>包含4路50KHz高速</br>数字量输出：16路，<br/>包含2路100KHz高速</br>模拟量输入：无<br/>模拟量输出：无</br>以太网(100M)：无</br>RS485：1路</br>RS232：1路',
						Intro:'卧式壳体</br>具有高速输入通道'
					},
					{
						id: '184',
						thumbnail:require('@/assets/images/edge/Active/产品页/05_CIO系列小型控制器/产品缩略图/CIO211_1-1.png'),
						PTName:'CIO211',
						Resource:'数字量输入：16路，<br/>包含4路50KHz高速</br>数字量输出：16路，<br/>包含2路100KHz高速</br>模拟量输入：无<br/>模拟量输出：无</br>以太网(100M)：1路</br>RS485：2路</br>RS232：1路',
						Intro:'卧式壳体</br>具有以太网口'
					},
					{
						id: '185',
						thumbnail:require('@/assets/images/edge/Active/产品页/05_CIO系列小型控制器/产品缩略图/CIO314_1-1.jpg'),
						PTName:'CIO314',
						Resource:'数字量输入：15路，<br/>包含4路20KHz高速</br>数字量输出：10路</br>模拟量输入：无<br/>模拟量输出：无</br>以太网(100M)：无</br>RS485：3路',
						Intro:'继电器输出</br>220V供电'
					}
				]
			}
			// 扩展IO模块 - 主分类 6 (会加载所有子分类)
			else if(SerialID == '6_1'){ // 开关量输入模块 (ID: 191-194)
				data = [
					{
						id: '191',
						thumbnail:require('@/assets/images/edge/Active/产品页/06_扩展IO模块/开关量输入模块/产品缩略图/EIO102&103_1-1.jpg'),
						PTName:'EIO102&103',
						Resource:'EIO102：16路数字量输入<br/>EIO103：20路数字量输入',
						Intro:'双向输入模块'
					}
				]
			}
			else if(SerialID == '6_2'){ // 开关量输出模块 (ID: 195-199)
				data = [
					{
						id: '195',
						thumbnail:require('@/assets/images/edge/Active/产品页/06_扩展IO模块/开关量输出模块/产品缩略图/EIO162&162P_1-1.jpg'),
						PTName:'EIO162&162P',
						Resource:'16路晶体管输出',
						Intro:'EIO162：NPN输出型<br/>EIO162P：PNP输出'
					},
					{
						id: '196',
						thumbnail:require('@/assets/images/edge/Active/产品页/06_扩展IO模块/开关量输出模块/产品缩略图/EIO163&163P_1-1.jpg'),
						PTName:'EIO163&163P',
						Resource:'20路晶体管输出',
						Intro:'EIO163：NPN输出型<br/>EIO163P：PNP输出'
					},
					{
						id: '197',
						thumbnail:require('@/assets/images/edge/Active/产品页/06_扩展IO模块/开关量输出模块/产品缩略图/EIO171&172_1-1.jpg'),
						PTName:'EIO171&172',
						Resource:'EIO171：8路继电器输出<br/>EIO172：16路继电器输出',
						Intro:''
					}
				]
			}
			else if(SerialID == '6_3'){ // 模拟量输入模块 (ID: 201-210)
				data = [
					{
						id: '201',
						thumbnail:require('@/assets/images/edge/Active/产品页/06_扩展IO模块/模拟量输入模块/产品缩略图/EA200_1-1.jpg'),
						PTName:'EA200系列',
						Resource:'EA201 4~20mA和0~5V</br>EA202 热电偶</br>EA203 PT100热电阻</br>EA204 -10~+10V</br>EA205 PT1000热电阻</br>EA206 高精度PT1000热电阻</br>EA207 S/R铂热电偶</br>EA208 B铂热电偶',
						Intro:'6路模拟量输入，支持各种通道类型'
					},
					{
						id: '202',
						thumbnail:require('@/assets/images/edge/Active/产品页/06_扩展IO模块/模拟量输入模块/产品缩略图/EA210_1-1.jpg'),
						PTName:'EA210系列',
						Resource:'EA211 4~20mA和0~5V</br>EA212 热电偶</br>EA213 PT100热电阻</br>EA214 -10~+10V</br>EA215 PT1000热电阻</br>EA216 高精度PT1000热电阻</br>EA217 S/R铂热电偶</br>EA218 B铂热电偶',
						Intro:'8路模拟量输入，支持各种通道类型'
					},
					{
						id: '203',
						thumbnail:require('@/assets/images/edge/Active/产品页/06_扩展IO模块/模拟量输入模块/产品缩略图/EA120_1-1.jpg'),
						PTName:'EA120系列',
						Resource:'12路热电偶模拟量输入',
						Intro:'12路输入'
					},
					{
						id: '204',
						thumbnail:require('@/assets/images/edge/Active/产品页/06_扩展IO模块/模拟量输入模块/产品缩略图/EA130_1-1.jpg'),
						PTName:'EA130系列',
						Resource:'8路0~20mA和0~5V模拟量输入',
						Intro:'8路全部支持高速电流电压输入'
					}
				]
			}
			else if(SerialID == '6_4'){ // 模拟量输出模块 (ID: 211-215)
				data = [
					{
						id: '211',
						thumbnail:require('@/assets/images/edge/Active/产品页/06_扩展IO模块/模拟量输出模块/产品缩略图/EA155&156_1-1.jpg'),
						PTName:'EA155&156',
						Resource:'EA155 4路0~20mA模拟量输出</br>EA156 8路0~20mA模拟量输出',
						Intro:'0~20mA电流输出'
					},
					{
						id: '212',
						thumbnail:require('@/assets/images/edge/Active/产品页/06_扩展IO模块/模拟量输出模块/产品缩略图/EA165&166_1-1.jpg'),
						PTName:'EA165&166',
						Resource:'EA165 4路0~20V模拟量输出</br>EA166 8路0~20V模拟量输出',
						Intro:'0~20V电压输出'
					},
					{
						id: '213',
						thumbnail:require('@/assets/images/edge/Active/产品页/06_扩展IO模块/模拟量输出模块/产品缩略图/EA167&168_1-1.jpg'),
						PTName:'EA167&168',
						Resource:'EA167 4路-10~10V模拟量输出</br>EA168 8路-10~10V模拟量输出',
						Intro:'-10~10V电压输出'
					}
				]				
			}
			else if(SerialID == '6_5'){ // 模拟量输入输出模块 (ID: 216-220)
				data = [
					{
						id: '216',
						thumbnail:require('@/assets/images/edge/Active/产品页/06_扩展IO模块/模拟量输入输出模块/产品缩略图/EA170_1-1.jpg'),
						PTName:'EA171~175',
						Resource:'EA171 4路0-5V/4-20mA模拟量输入</br>EA172 4路热电偶模拟量输入</br>EA173 4路PT100热电阻模拟量输入</br>EA174 4路-5~5V/-20~20mA模拟量输入</br>EA175 4路PT1000热电阻模拟量输入</br></br>输出通道共4路，通道类型统一为 2路4-20mA + 2路0-20V 模拟量输出',
						Intro:'8路模拟量输入输出模块。</br>其中包含4路输入，输入通道类型各不相同;</br>以及4路输出，输出通道类型一致'
					},
					{
						id: '217',
						thumbnail:require('@/assets/images/edge/Active/产品页/06_扩展IO模块/模拟量输入输出模块/产品缩略图/EA170_1-1.jpg'),
						PTName:'EA176~178',
						Resource:'EA176 高精度4路PT1000热电阻模拟量输入</br>EA177 高精度4路PT1000热电阻模拟量输入</br>EA178 高精度4路S/R铂热电偶模拟量输入',
						Intro:`8路模拟量输入输出模块。</br>其中包含4路输入，输入通道类型各不相同;</br>以及4路输出，输出通道类型一致
						</br>支持高精度模拟量输入`
					}
				]
			}
			// 电源模块 7 (ID: 231-235)
			else if(SerialID == '7'){
				data = [
					{
						id: '231',
						thumbnail:require('@/assets/images/edge/Active/产品页/07_电源模块/产品缩略图/CPS200_1-1.jpg'),
						PTName:'CPS200',
						Resource:'功率100W,</br>输入150~260VA</br>输出2组隔离24V输出，每组额定电流4A',
						Intro:'具有2组隔离24V输出'
					}
				]
			}
			else if(SerialID == '6_6'){ // 电力监控扩展模块 (ID: 221-225)
				data = [
					{
						id: '221',
						thumbnail:require('@/assets/images/edge/Active/产品页/06_扩展IO模块/电力监控扩展模块/产品缩略图/EPM102_1-1.jpg'),
						PTName:'EPM102',
						Resource:'3路0~9V电压交流输入，分辨率0.5V</br>9路0~5A电流交流输入，分辨率0.5A</br>工频频率：0~400HZ，分辨率:0.5Hz。</br>功率因数:-1.000~1.000;</br>分辨率：0.1%',
						Intro:'用于电力监控</br>3路交流电压输入，9路交流电流输入'
					}
				]
			}
			else if(SerialID == '6_7'){ // 温控及采集模块 (ID: 226-230)
				data = [
					{
						id: '226',
						thumbnail:require('@/assets/images/edge/Active/产品页/06_扩展IO模块/温控及采集模块/产品缩略图/TAC6000_1-1.png'),
						PTName:'TAC6000',
						Resource:'数字量输入：3路</br>数字量输出：9路</br>模拟量输入：8路<br/>模拟量输出：无</br>以太网(100M)：无</br>RS485：1路',
						Intro:'温控模块'
					},
					{
						id: '227',
						thumbnail:require('@/assets/images/edge/Active/产品页/06_扩展IO模块/温控及采集模块/产品缩略图/TAM4000_1-1.png'),
						PTName:'TAM4000',
						Resource:'数字量输入：3路</br>数字量输出：9路</br>模拟量输入：8路<br/>模拟量输出：无</br>以太网(100M)：无</br>RS485：1路',
						Intro:'温度采集模块，</br>不支持编程功能'
					},
					{
						id: '228',
						thumbnail:require('@/assets/images/edge/Active/产品页/06_扩展IO模块/温控及采集模块/产品缩略图/DUT4100_1-1.png'),
						PTName:'DUT4100',
						Resource:'模拟量输入：8路普通</br>数字量输出：8路普通</br>以太网(100M)：无</br>RS485：1路(同时具有1路并口通讯)',
						Intro:'温控及采集模块，</br>物理尺寸：146mm×98mm×45mm，</br>功耗：小于1.5W，</br>支持MODBUS RTU/ASCⅡ协议'
					}
				]
			}
			// 专用产品 8 (ID: 241-260)
			else if(SerialID == '8'){
				data = [
					{
						id: '241',
						thumbnail:require('@/assets/images/edge/Active/产品页/08_专用产品/产品缩略图/NCC2040_1-1.jpg'),
						PTName:'NCC2040',
						Resource:'数字量输入：12路，全部是探丝器</br>数字量输出：24路，其中12路切丝器，12路指示灯<br/>RS485：1路',
						Intro:'纺织机械专用产品，</br>支持可编程控制'
					},
					{
						id: '242',
						thumbnail:require('@/assets/images/edge/Active/产品页/08_专用产品/产品缩略图/NCC2010A_1-1.png'),
						PTName:'NCC2010A',
						Resource:'数字量输入：37路（NPN）</br>数字量输出：36路（PNP）</br>RS485：1路</br>通信协议：MODBUS RTU/ASCII',
						Intro:'纺织机械专用产品</br>支持探丝器输入和切丝器输出</br>37路DI/36路DO'
					},
					{
						id: '243',
						thumbnail:require('@/assets/images/edge/Active/产品页/08_专用产品/产品缩略图/MCD1000_1-1.jpg'),
						PTName:'MCD1000',
						Resource:'数字量输入：32路</br>数字量输出：16路</br>模拟量输入：6路<br/>模拟量输出：2路</br>以太网(100M)：2路</br>RS485：2路',
						Intro:'起重机监控控制器'
					},
					{
						id: '244',
						thumbnail:require('@/assets/images/edge/Active/产品页/08_专用产品/产品缩略图/RY_1000_1-1.png'),
						PTName:'RY1000',
						Resource:'测量范围：0～200.0μg/L 或 0～20.00mg/L</br>分辨率：0.1μg/L 或 0.1mg/L</br>相对精度：±0.5％FS</br>自动温度补偿范围：-40～85℃</br>工作电压：24VDC</br>防护等级：IP65',
						Intro:'溶解氧调理板，</br>外形尺寸：110mm×80mm×47mm，</br>信号处理能力：MCI8000 2路'
					},
					{
						id: '245',
						thumbnail:require('@/assets/images/edge/Active/产品页/08_专用产品/产品缩略图/DD_1000_1-1.png'),
						PTName:'DD1000',
						Resource:'测量范围：0.055μS/cm～199.9mS/cm</br>分辨率：0.015μS/cm 或 0.1mS/cm</br>相对精度：±0.5％FS</br>自动温度补偿范围：-40～85℃</br>工作电压：24VDC</br>防护等级：IP65',
						Intro:'电导率调理板，</br>外形尺寸：110mm×80mm×47mm，</br>信号处理能力：MCI8000 3路'
					},
					{
						id: '246',
						thumbnail:require('@/assets/images/edge/Active/产品页/08_专用产品/产品缩略图/NA_1000_1-1.png'),
						PTName:'NA1000',
						Resource:'测量范围：0～7pNa</br>分辨率：0.001pNa</br>相对精度：±0.5％FS</br>自动温度补偿范围：-40～85℃</br>工作电压：24VDC</br>防护等级：IP65',
						Intro:'钠调理板，</br>外形尺寸：110mm×80mm×47mm，</br>信号处理能力：MCI8000 3路'
					},
					{
						id: '247',
						thumbnail:require('@/assets/images/edge/Active/产品页/08_专用产品/产品缩略图/PH_1000_1-1.png'),
						PTName:'PH1000',
						Resource:'测量范围：0.00～14.00pH</br>分辨率：0.05pH</br>相对精度：±0.5％FS</br>自动温度补偿范围：-40～85℃</br>工作电压：24VDC</br>防护等级：IP65',
						Intro:'酸碱浓度调理板，</br>外形尺寸：110mm×80mm×47mm，</br>信号处理能力：MCI8000 3路'
					}
				]
			}
			else if(SerialID == '9_1'){ // 环网伺服器 (ID: 261-265)
				data=[
					{
						id: '261',
						thumbnail:require('@/assets/images/edge/Active/产品页/09_环网伺服器与伺服电机/环网伺服器/产品缩略图/CUS_N_1-1.jpg'),
						PTName:'CUS000系列',
						Resource:'输入3相220V AC，</br>数字量输入：10路</br>数字量输出：6路</br>2路0~10V输入，</br>1路-10V~+10V输入，</br>2路0~3V输出，</br>以太网(100M)：2路，</br>RS485：1路。',
						Intro:'支持回原点、往复运动、恒速运动、定位控制和手轮控制等功能'
					}
				]
			}
			else if(SerialID == '9_2'){ // 伺服电机 (ID: 266-270)
				data=[
					{
						id: '266',
						thumbnail:require('@/assets/images/edge/Active/产品页/09_环网伺服器与伺服电机/伺服电机/产品缩略图/xxkw_1-1.jpg'),
						PTName:'60SFM系列',
						Resource:'0.2kw~2.0kw',
						Intro:''
					}
				]
			}
			// 软件产品 10 (ID: 271-280)
			else if(SerialID == '10'){
				data=[
					{
						id: '271',
						thumbnail:require('@/assets/images/edge/Active/产品页/10_软件产品/产品缩略图/PLCConfig_1-1.png'),
						PTName:'PLC_Config',
						Resource:'功能块编程<br/>梯形图编程',
						Intro:'公司专为各系列可编程控制器进行逻辑编程而自主开发的T型图，功能块组态软件。'
					},
					{
						id: '272',
						thumbnail:require('@/assets/images/edge/Active/产品页/10_软件产品/产品缩略图/Dview_1-1.png'),
						PTName:'DView HMI',
						Resource:'设备拓扑<br/>组态编程',
						Intro:'公司自主研发的具有设备管理、实时数据管理、视频管理、数据库管理和地理信息管理等功能的监控管理系统开发平台。'
					}
				]
			}
			this.edgeProductsIntroKey = SerialID;
			this.edgeProductsIntro = data;
						
			// console.log("edgeProductsIntroKey="+this.edgeProductsIntroKey+",edgeProductsIntro=")
			// console.log(this.edgeProductsIntro)
		},

		/* 获取所有产品列表，用于搜索 */
		getAllProducts() {
			let allProducts = [];

			// 定义分类名称映射
			const categoryNames = {
				'21': 'PAG系列',
				'1_2_1': 'MEG主控制器',
				'1_2_2': 'MEG拓展IO模块',
				'2': 'MAC中型控制器',
				'3': 'MAC运动控制器',
				'20': '冗余主控器',
				'4': '以太网控制器',
				'5': '分布式扩展模块',
				'6': 'EDC系列可编程嵌入式开发平台',
				'7': 'CIO系列小型控制器',
				'8': '开关量输入模块',
				'9': '开关量输出模块',
				'10': '模拟量输入模块',
				'11': '模拟量输出模块',
				'12': '模拟量输入输出模块',
				'18': '电力监控扩展模块',
				'19': '温控及采集模块',
				'13': '电源模块',
				'14': '专用产品',
				'15': '环网伺服器',
				'16': '伺服电机',
				'17': '软件产品'
			};

			// 遍历所有SerialID获取产品（MEG系列使用新的三级子分类slug）
			const serialIds = [21, '1_2_1', '1_2_2', 2, 3, 20, 4, 5, 6, 7, 8, 9, 10, 11, 12, 18, 19, 13, 14, 15, 16, 17];

			serialIds.forEach(serialId => {
				// 调用getCategoriesData获取该分类的产品
				this.getCategoriesData(serialId);
				const tempData = [...this.edgeProductsIntro];

				// 为每个产品添加分类名称和分类ID
				const categoryName = categoryNames[serialId.toString()] || '';
				tempData.forEach(product => {
					product.categoryName = categoryName;
					product.categoryId = serialId;
				});

				allProducts = allProducts.concat(tempData);
			});

			return allProducts;
		},

	},
    created() {

    }
}